'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTether = require('react-tether');

var _reactTether2 = _interopRequireDefault(_reactTether);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Suggest = function (_Component) {
  (0, _inherits3.default)(Suggest, _Component);
  (0, _createClass3.default)(Suggest, null, [{
    key: 'isSearchTextMatchSuggest',
    value: function isSearchTextMatchSuggest(suggestion, sanitizedSearchText) {
      var emphasizedTextCandidateArr = sanitizedSearchText.toLowerCase().split(' ');
      var emphasizedTextInfoArr = [];
      var length = emphasizedTextCandidateArr.length;
      for (var i = 0; i < length; i += 1) {
        var pos = suggestion.toLowerCase().indexOf(emphasizedTextCandidateArr[i]);
        if (pos === -1) return false;
        emphasizedTextInfoArr.push({
          pos: pos,
          length: emphasizedTextCandidateArr[i].length
        });
      }
      emphasizedTextInfoArr.sort(function (currentInfo, nextInfo) {
        return currentInfo.pos - nextInfo.pos;
      });
      return emphasizedTextInfoArr;
    }
  }]);

  function Suggest(props) {
    (0, _classCallCheck3.default)(this, Suggest);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Suggest.__proto__ || (0, _getPrototypeOf2.default)(Suggest)).call(this, props));

    _this.state = {
      isOpen: false,
      matchedSuggestList: [],
      suggestIndex: -1,
      // the search destination
      searchText: props.destination || ''
    };
    _this.bindHandleKeyDown = _this.handleKeyDown.bind(_this);
    _this.bindUpdateSuggestList = _this.updateSuggestList.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Suggest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.bindHandleClickOutSide = this.handleClickOutside.bind(this);
      document.addEventListener('click', this.bindHandleClickOutSide, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        searchText: nextProps.destination || ''
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.bindHandleClickOutSide, true);
    }
    // XXX: expose this method to the parent when the Enter key is pressed

  }, {
    key: 'getSuggestKey',
    value: function getSuggestKey() {
      if (!this.state.matchedSuggestList.length) {
        return;
      }
      var index = this.state.suggestIndex > 0 ? this.state.suggestIndex : 0;
      // eslint-disable-next-line consistent-return
      return this.state.matchedSuggestList[index].searchKey;
    }
  }, {
    key: 'getMatchedSuggestList',
    value: function getMatchedSuggestList(sanitizedSearchText) {
      var matchedSuggestList = [];
      var length = window.list.length;
      for (var i = 0; i < length; i += 1) {
        if (window.list[i]) {
          if (matchedSuggestList.length === this.props.limit) break;
          var suggestion = window.list[i];
          var emphasizedTextInfoArr = Suggest.isSearchTextMatchSuggest(suggestion[3], sanitizedSearchText);
          if (emphasizedTextInfoArr) {
            var type = {
              state: 'area',
              city: 'area'
            }[suggestion[1]] || suggestion[1];
            var searchKey = suggestion[6] + ', ' + suggestion[7].join(', ');
            var displayText = suggestion[3] + ', ' + suggestion[5].join(', ');
            matchedSuggestList.push({
              searchKey: searchKey,
              displayText: displayText,
              type: type,
              emphasizedTextInfoArr: emphasizedTextInfoArr
            });
          }
        }
      }
      return matchedSuggestList;
    }
    // update suggest list each time users type in the searchbox

  }, {
    key: 'updateSuggestList',
    value: function updateSuggestList(event) {
      var searchText = event.target.value;
      var sanitizedSearchText = searchText.trim().replace(/\s\s+/g, ' ');
      if (!sanitizedSearchText.length) {
        this.setState({
          matchedSuggestList: [],
          searchText: searchText,
          suggestIndex: -1
        });
        this.props.onChange('');
      } else {
        var matchedSuggestList = this.getMatchedSuggestList(sanitizedSearchText);
        this.setState({
          isOpen: true,
          matchedSuggestList: matchedSuggestList,
          searchText: searchText,
          suggestIndex: -1
        });
      }
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(evt) {
      var textDOM = this.text;
      var suggestDOM = this.suggest;

      if ((!textDOM || !textDOM.contains(evt.target)) && (!suggestDOM || !suggestDOM.contains(evt.target))) {
        this.setState({ isOpen: false });
      }
    }
  }, {
    key: 'updateSuggestIndex',
    value: function updateSuggestIndex(index) {
      if (!this.state.matchedSuggestList.length) {
        return;
      }

      this.setState({
        suggestIndex: index,
        searchText: this.state.matchedSuggestList[index].displayText
      });
      this.props.onChange(this.state.matchedSuggestList[index].searchKey);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      var nextSuggestIndex = void 0;
      switch (event.key) {
        case 'ArrowUp':
          nextSuggestIndex = this.state.suggestIndex - 1 < 0 ? this.state.matchedSuggestList.length - 1 : this.state.suggestIndex - 1;
          this.updateSuggestIndex(nextSuggestIndex);
          break;
        case 'ArrowDown':
          nextSuggestIndex = this.state.suggestIndex + 1 === this.state.matchedSuggestList.length ? 0 : this.state.suggestIndex + 1;
          this.updateSuggestIndex(nextSuggestIndex);
          break;
        default:
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          placeholder = _props.placeholder,
          hasError = _props.hasError;
      var isOpen = this.state.isOpen;

      var searchText = this.state.searchText;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactTether2.default,
          {
            attachment: 'top left',
            targetAttachment: 'bottom left'
          },
          _react2.default.createElement(
            'div',
            { htmlFor: 'location-input' },
            _react2.default.createElement(
              'span',
              { className: 'for-reader' },
              placeholder
            ),
            _react2.default.createElement('input', {
              id: 'location-input',
              className: 'location-input ' + (hasError ? 'invalid' : ''),
              name: 'destination',
              ref: function ref(text) {
                _this2.text = text;
              },
              type: 'text',
              placeholder: placeholder,
              autoComplete: 'off',
              value: searchText,
              onChange: this.bindUpdateSuggestList,
              onFocus: function onFocus() {
                _this2.setState({
                  isOpen: true
                });
              },
              onKeyDown: this.bindHandleKeyDown
            })
          ),
          _react2.default.createElement(
            'div',
            {
              id: 'suggest',
              className: 'featureSuggest',
              ref: function ref(suggest) {
                _this2.suggest = suggest;
              },
              style: {
                // show suggest list when a character is input
                display: isOpen && searchText.length ? 'block' : 'none',
                position: 'relative'
              }
            },
            _react2.default.createElement(
              'div',
              { className: 'suggest' },
              _react2.default.createElement(
                'div',
                { className: 'suggest-heading' },
                '"',
                searchText,
                '"'
              ),
              _react2.default.createElement(
                'div',
                { className: 'suggest-content' },
                _react2.default.createElement(
                  'ul',
                  { className: 'suggest-list' },
                  this.state.matchedSuggestList.map(function (suggestion, keyIndex) {
                    var emphasizedTextInfoArr = suggestion.emphasizedTextInfoArr;
                    var displayText = suggestion.displayText;
                    var startPos = 0;
                    return (
                      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                      _react2.default.createElement(
                        'li',
                        {
                          key: keyIndex,
                          onClick: function onClick(evt) {
                            evt.preventDefault();
                            _this2.updateSuggestIndex(keyIndex);
                            _this2.setState({
                              isOpen: false
                            });
                          }
                        },
                        _react2.default.createElement(
                          'div',
                          { className: 'item-label' },
                          _react2.default.createElement('i', { className: 'icon-' + suggestion.type }),
                          _react2.default.createElement(
                            'span',
                            null,
                            suggestion.type
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'item' },
                          emphasizedTextInfoArr.map(function (emphasizedTextInfo) {
                            var nextEmphasizedStartPos = emphasizedTextInfo.pos;
                            var nextEmphasizedTextLength = emphasizedTextInfo.length;
                            var emphasizedItem = null;
                            if (nextEmphasizedStartPos >= startPos) {
                              // no overlapped emphasized part
                              emphasizedItem = [displayText.substring(startPos, nextEmphasizedStartPos), _react2.default.createElement(
                                'b',
                                null,
                                displayText.substring(nextEmphasizedStartPos, nextEmphasizedStartPos + nextEmphasizedTextLength)
                              )];
                              startPos = nextEmphasizedStartPos + nextEmphasizedTextLength;
                            } else {
                              var endPos = nextEmphasizedStartPos + nextEmphasizedTextLength;
                              if (endPos > startPos) {
                                // extend the bold part from startPos
                                emphasizedItem = _react2.default.createElement(
                                  'b',
                                  null,
                                  displayText.substring(startPos, endPos)
                                );
                                startPos = endPos;
                              }
                            }
                            return emphasizedItem;
                          }),
                          displayText.substring(startPos)
                        )
                      )
                    );
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Suggest;
}(_react.Component);

Suggest.propTypes = {
  placeholder: _react.PropTypes.string.isRequired,
  hasError: _react.PropTypes.bool,
  onChange: _react.PropTypes.func.isRequired,
  destination: _react.PropTypes.string,
  limit: _react.PropTypes.number
};

Suggest.defaultProps = {
  onChange: function onChange() {},
  hasError: false,
  limit: 10
};

exports.default = Suggest;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Suggest.js
// module id = 1227
// module chunks = 0